<template>
  <v-card id="listener_aggiunta_riga_generale">
    <v-card-text class="mt-5" style="overflow-y: auto">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="2">
            <v-text-field
              dense
              hide-details
              @keydown.enter="cercaCommesse"
              label="Cod. Commessa"
              outlined
              v-model="riga_generale.cod_commessa"
              style="border-radius: 0px"
              v-on:keydown.enter="cercaCommesse"
            >
              <template v-slot:append-outer>
                <v-btn @click="cercaCommesse" small>
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              hide-details
              label="Cod. Articolo"
              outlined
              v-model="riga_generale.cod_articolo"
              readonly
              style="border-radius: 0px"
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-autocomplete
              dense
              hide-details
              label="Cod. Fase"
              :items="items_fasi_selezionabili"
              item-text="cod_des_fase"
              item-value="id_commessa_dettaglio"
              outlined
              v-model="riga_generale.id_commessa_dettaglio"
              style="border-radius: 0px"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              dense
              hide-details
              :items="items_macchine_selezionabili"
              item-text="cod_des_macchina"
              item-value="id_macchina"
              label="Macchina"
              outlined
              v-model="riga_generale.id_macchina"
              style="border-radius: 0px"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              dense
              hide-details
              :items="items_utenti"
              item-text="nominativo"
              item-value="id_utente"
              label="Personale"
              outlined
              v-model="riga_generale.id_personale"
              style="border-radius: 0px"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <!-- Data Start -->
          <v-col cols="3">
            <v-menu
              v-model="calendario_data_start"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="289"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  background-color="#ffffff"
                  dense
                  hide-details
                  label="Data Start"
                  outlined
                  v-model="start_formattato"
                  readonly
                  style="border-radius: 0px"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                locale="it"
                v-model="riga_generale.data_start"
                @input="
                  calendario_data_start = false;
                  checkCalendarInterval();
                "
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- Ora start -->
          <v-col cols="3">
            <v-menu
              v-model="calendario_ora_start"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="350px"
              min-width="350px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  hide-details
                  v-model="riga_generale.ora_start"
                  label="Ora Start"
                  outlined
                  readonly
                  style="border-radius: 0px"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                format="ampm"
                v-model="riga_generale.ora_start"
                full-width
                @click:second="calendario_ora_start = false"
                use-seconds
              ></v-time-picker>
            </v-menu>
          </v-col>

          <!-- Data Stop -->
          <v-col cols="3">
            <v-menu
              v-model="calendario_data_stop"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="289"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  background-color="#ffffff"
                  hide-details
                  label="Data Stop"
                  outlined
                  v-model="stop_formattato"
                  readonly
                  style="border-radius: 0px"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                locale="it"
                v-model="riga_generale.data_stop"
                @input="
                  calendario_data_stop = false;
                  checkCalendarInterval();
                "
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- Ora stop -->
          <v-col cols="3">
            <v-menu
              v-model="calendario_ora_stop"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="350px"
              min-width="350px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  hide-details
                  v-model="riga_generale.ora_stop"
                  label="Ora Stop"
                  outlined
                  readonly
                  style="border-radius: 0px"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                format="ampm"
                v-model="riga_generale.ora_stop"
                full-width
                @click:second="calendario_ora_stop = false"
                use-seconds
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3">
            <v-autocomplete
              dense
              hide-details
              :items="items_turni"
              item-text="cod_turno"
              item-value="id_turno"
              label="Turno"
              outlined
              style="border-radius: 0px"
              v-model.number="riga_generale.id_turno"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="3">
            <v-text-field
              dense
              hide-details
              v-model.number="totale_pezzi"
              label="Quantità OK"
              outlined
              readonly
              style="border-radius: 0px"
              type="number"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="showPezzi" small v-bind="attrs" v-on="on">
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Dichiara Produzione</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="3">
            <v-text-field
              dense
              hide-details
              v-model.number="totale_scarti"
              label="Scarti"
              outlined
              readonly
              style="border-radius: 0px"
              type="number"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="showScarti" small v-bind="attrs" v-on="on">
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Dichiara Fermi</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="3">
            <v-text-field
              dense
              hide-details
              v-model.number="totale_fermi"
              label="Fermi"
              outlined
              readonly
              style="border-radius: 0px"
              type="number"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="showFermi" small v-bind="attrs" v-on="on">
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Dichiara Fermi</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog scarti -->
    <v-dialog v-model="dialog_scarti" width="700">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Scarti </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di aggiunta riga scarto -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="aggiungiRigaScarti"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Scarto</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaScarti" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Scarti</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_scarti = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers_scarti"
                  :items="items_scarti_tmp.filter((elem) => elem.validita == 1)"
                >
                  <!-- Colonna della quantità -->
                  <template v-slot:[`item.pezzi`]="{ item }">
                    <v-text-field
                      background-color="white"
                      dense
                      hide-details
                      outlined
                      style="border-radius: 0px; max-width: 150px"
                      type="number"
                      v-model.number="item.pezzi"
                    ></v-text-field>
                  </template>

                  <!-- Colonna della descrizione -->
                  <template v-slot:[`item.id_causale`]="{ item }">
                    <v-autocomplete
                      background-color="white"
                      dense
                      hide-details
                      :items="items_causali_scarto"
                      item-text="des"
                      item-value="id_causale"
                      outlined
                      style="border-radius: 0px; max-width: 250px"
                      v-model="item.id_causale"
                    ></v-autocomplete>
                  </template>

                  <!-- Colonna dell'eliminazione -->
                  <template v-slot:[`item.elimina`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="clickEliminaCausaleScarto(item)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                      </template>
                      <span>Elimina</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog fermi -->
    <v-dialog v-model="dialog_fermi" width="800">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Fermi </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di aggiunta riga fermo -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="aggiungiRigaFermi"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Fermo</span>
          </v-tooltip>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaFermi" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_fermi = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            :headers="headers_fermi"
            :items="items_fermi_tmp.filter((elem) => elem.validita == 1)"
          >
            <!-- Colonna della quantità -->
            <template v-slot:[`item.minuti`]="{ item }">
              <v-text-field
                background-color="white"
                dense
                hide-details
                outlined
                style="border-radius: 0px; max-width: 100px"
                type="number"
                v-model.number="item.minuti"
              ></v-text-field>
            </template>

            <!-- Colonna della descrizione -->
            <template v-slot:[`item.id_causale`]="{ item }">
              <v-autocomplete
                background-color="white"
                dense
                hide-details
                :items="items_causali_fermo"
                item-text="des"
                item-value="id_tabella"
                outlined
                style="border-radius: 0px; max-width: 450px"
                v-model.number="item.id_causale"
              ></v-autocomplete>
            </template>

            <!-- Colonna del dettaglio -->
            <template v-slot:[`item.tipo`]="{ item }">
              <v-autocomplete
                background-color="white"
                dense
                hide-details
                :items="items_tipi_causali"
                item-text="des"
                item-value="id_tabella"
                outlined
                style="border-radius: 0px; max-width: 350px"
                v-model="item.tipo"
              >
                <template v-slot:append>
                  <v-icon
                    @click="item.tipo = null"
                    color="error"
                    v-if="item.tipo != null && item.tipo != ''"
                  >
                    mdi-close
                  </v-icon>
                </template>
              </v-autocomplete>
            </template>

            <!-- Colonna dell'eliminazione -->
            <template v-slot:[`item.elimina`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickEliminaCausaleFermo(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Elimina</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_seleziona_commessa" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Commessa
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_commessa = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_commesse_selezionabili"
                  :items="
                    items_commesse_selezionabili.filter((e) => e.visible === 1)
                  "
                >
                  <template v-slot:top>
                    <v-container lfuid>
                      <v-row>
                        <v-col cols="6">
                          <v-autocomplete
                            @change="filtra"
                            :items="
                              items_commesse_selezionabili.filter(
                                (e) => e.visible === 1
                              )
                            "
                            item-text="cod_commessa"
                            item-value="cod_commessa"
                            label="Cod. Commessa"
                            v-model="cod_commessa_filter"
                          >
                            <template slot="append">
                              <v-icon
                                @click="
                                  cod_commessa_filter = '';
                                  filtra();
                                "
                                color="primary"
                              >
                                mdi-filter-off
                              </v-icon>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete
                            @change="filtra"
                            :items="
                              items_commesse_selezionabili.filter(
                                (e) => e.visible === 1
                              )
                            "
                            item-text="cod_articolo"
                            item-value="cod_articolo"
                            label="Cod. Articolo"
                            v-model="cod_articolo_filter"
                          >
                            <template slot="append">
                              <v-icon
                                @click="
                                  cod_articolo_filter = '';
                                  filtra();
                                "
                                color="primary"
                              >
                                mdi-filter-off
                              </v-icon>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <template v-slot:[`item.seleziona`]="{ item }">
                    <v-btn @click="selezionaCommessa(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione fermo -->
    <v-dialog v-model="dialog_conferma_elimina_fermo" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare il fermo selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_elimina_fermo = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaCausaleFermo" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione fermo -->
    <v-dialog v-model="dialog_conferma_elimina_scarto" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare lo scarto selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_elimina_scarto = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaCausaleScarto" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione pezzo -->
    <v-dialog v-model="dialog_conferma_elimina_pezzo" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare la registrazione selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_elimina_pezzo = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaPezzo" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog dichiarazione pezzi ok -->
    <v-dialog persistent class="mt-5" width="90%" v-model="dialog_pezzi">
      <v-card elevation="0" min-height="300px">
        <v-toolbar
          color="indigo"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-toolbar-title class="white--text"> Produzione </v-toolbar-title>

          <v-spacer />

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaPezziOK()"
                class="mr-5"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="aggiungiDichiarazionePezzi"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Riga</span>
          </v-tooltip>

          <v-spacer />

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiDialogPezzi" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :headers="headers_pezzi_ok"
            :items="items_pezzi_ok_tmp.filter((elem) => elem.validita == 1)"
          >
            <!-- Bottone di modifica dei pezzi OK -->
            <template v-slot:[`item.modifica`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="modificaSingolaRigaPezzi(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="primary"> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Modifica</span>
              </v-tooltip>
            </template>

            <!-- Bottone di eliminazione -->
            <template v-slot:[`item.elimina`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickEliminaPezzo(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Modifica</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica riga in Pezzi -->
    <v-dialog persistent v-model="dialog_edit_pezzo" width="800px">
      <v-card>
        <!-- Toolbar -->
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="left" cols="4">
              <v-toolbar-title class="white--text">
                Dettaglio Pezzi
              </v-toolbar-title>
            </v-col>

            <v-col align="center" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="salvaPezzo" small v-bind="attrs" v-on="on">
                    <v-icon color="success"> mdi-floppy </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>

            <v-col align="right" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="dialog_edit_pezzo = false"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <!-- Corpo della card -->
        <v-card-text class="mt-5">
          <v-container>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12" justify="center">
                <v-text-field
                  class="centered-input"
                  dense
                  hide-details
                  label="Quantità"
                  :min="0"
                  outlined
                  style="border-radius: 0px; max-width: 250px"
                  type="number"
                  v-model.number="pezzo_sel.quantita"
                />
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12">
                <v-textarea
                  v-model="pezzo_sel.note"
                  placeholder="Note"
                  label="Note"
                  outlined
                  style="border-radius: 0px"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_stringa" width="500">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Discorso </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog_stringa = false" small>
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-textarea v-model="stringa" outlined></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_avviso_tempi" width="400px">
      <v-card>
        <v-toolbar color="orange" dense>
          <v-toolbar-title class="white--text">
            Differenza Start e Stop
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 18px">
            Attenzione, la differenza fra le date di inizio e fine appena
            inserite è di
            {{ differenza_tempi }} {{ differenza_tempi > 1 ? "mesi" : "mese" }}.
          </span>
          <div class="mt-5">
            <v-btn @click="dialog_avviso_tempi = false" small>
              <span style="color: orange"> Ho capito </span>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Loader -->
    <v-overlay :value="caricamento_dati" absolute z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class CollateralePezzi {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod_commessa", default_val: "" },
      { nome: "cod_fase", default_val: "" },
      { nome: "cod_macchina", default_val: "" },
      { nome: "data", default_val: "" },
      { nome: "des_fase", default_val: "" },
      { nome: "id_articolo", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "id_macchina", default_val: null },
      { nome: "id_movimento", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "nominativo", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "quantita", default_val: 0 },
      { nome: "riferimento", default_val: 0 },
      { nome: "tipo_record", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class Causale {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "minuti", default_val: null },
      { nome: "pezzi", default_val: null },
      { nome: "tipo", default_val: null },
      { nome: "tipo_record", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class RigaGenerale {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "causale", default_val: "", complex: false },
      { nome: "cod_articolo", default_val: "", complex: false },
      { nome: "cod_commessa", default_val: "", complex: false },
      { nome: "cod_fase", default_val: "", complex: false },
      { nome: "cod_lotto", default_val: "", complex: false },
      { nome: "cod_macchina", default_val: "", complex: false },
      { nome: "data_start", default_val: "", complex: false },
      { nome: "data_stop", default_val: "", complex: false },
      { nome: "des_fase", default_val: "", complex: false },
      { nome: "fermi", default_val: new Array(), complex: true },
      { nome: "flag_fase_ultima", default_val: 0, complex: false },
      { nome: "id_articolo", default_val: null, complex: false },
      { nome: "id_commessa", default_val: null, complex: false },
      { nome: "id_commessa_dettaglio", default_val: null, complex: false },
      { nome: "id_commessa_tempi", default_val: null, complex: false },
      { nome: "id_fase", default_val: null, complex: false },
      { nome: "id_macchina", default_val: null, complex: false },
      { nome: "id_personale", default_val: null, complex: false },
      { nome: "id_stato_fase", default_val: null, complex: false },
      { nome: "id_turno", default_val: null, complex: false },
      { nome: "nominativo", default_val: "", complex: false },
      { nome: "note", default_val: "", complex: false },
      { nome: "numero_commessa", default_val: null, complex: false },
      { nome: "ora_start", default_val: "", complex: false },
      { nome: "ora_stop", default_val: "", complex: false },
      { nome: "quantita", default_val: 0, complex: false },
      { nome: "riferimento", default_val: "", complex: false },
      { nome: "scarti", default_val: new Array(), complex: true },
      { nome: "validita", default_val: 1, complex: false },
    ];

    return campi;
  }
}

export default {
  name: "FormDichiarazione",
  components: { SnackbarQV },
  props: {
    riga_ori: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      causale_fermo_sel: new Causale(),
      causale_scarto_sel: new Causale(),
      cod_articolo_filter: "",
      cod_commessa_filter: "",
      differenza_tempi: null,
      pezzo_sel: new CollateralePezzi(),
      riga_generale: new RigaGenerale(),
      stringa: "",

      // Modal
      calendario_data_start: false,
      calendario_data_stop: false,
      dialog_edit_pezzo: false,
      calendario_ora_start: false,
      calendario_ora_stop: false,
      caricamento_dati: false,
      dialog_avviso_tempi: false,
      dialog_conferma_elimina_fermo: false,
      dialog_conferma_elimina_pezzo: false,
      dialog_conferma_elimina_scarto: false,
      dialog_stringa: false,
      dialog_fermi: false,
      dialog_pezzi: false,
      dialog_scarti: false,
      dialog_seleziona_commessa: false,

      // Array
      headers_commesse_selezionabili: [
        { text: "Cod. Commessa", value: "cod_commessa", sortable: false },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Selezione",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
      ],
      headers_fermi: [
        {
          text: "Minuti",
          value: "minuti",
          sortable: false,
          width: "160px",
        },
        { text: "Causale", value: "id_causale", sortable: false },
        { text: "Dettaglio", value: "tipo", sortable: false },
        { text: "Elimina", value: "elimina", sortable: false },
      ],
      headers_pezzi_ok: [
        {
          text: "Modifica",
          sortable: false,
          value: "modifica",
        },
        {
          text: "Data Dichiarazione",
          sortable: false,
          value: "_ora",
        },
        {
          text: "Nome",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Quantità",
          sortable: false,
          value: "quantita",
        },
        {
          text: "Note",
          sortable: false,
          value: "note",
        },
        {
          text: "Elimina",
          sortable: false,
          value: "elimina",
        },
      ],
      headers_scarti: [
        {
          text: "Quantità",
          value: "pezzi",
          sortable: false,
          width: "160px",
        },
        { text: "Causale", value: "id_causale", sortable: false },
        { text: "Elimina", value: "elimina", sortable: false },
      ],
      items_causali_fermo: new Array(),
      items_causali_scarto: new Array(),
      items_commesse_selezionabili: new Array(),
      items_fasi_selezionabili: new Array(),
      items_fermi: new Array(),
      items_fermi_tmp: new Array(),
      items_macchine_selezionabili: new Array(),
      items_pezzi_ok: new Array(),
      items_pezzi_ok_tmp: new Array(),
      items_scarti: new Array(),
      items_scarti_tmp: new Array(),
      items_tipi_causali: new Array(),
      items_turni: new Array(),
      items_utenti: new Array(),
    };
  },
  computed: {
    start_formattato() {
      return this.riga_generale.data_start != null &&
        this.riga_generale.data_start !== ""
        ? moment(this.riga_generale.data_start).format("DD/MM/YYYY")
        : "";
    },
    stop_formattato() {
      return this.riga_generale.data_stop != null &&
        this.riga_generale.data_stop !== ""
        ? moment(this.riga_generale.data_stop).format("DD/MM/YYYY")
        : "";
    },
    totale_fermi() {
      let res = 0;
      this.items_fermi
        .filter((elem) => elem.validita == 1)
        .forEach((f) => {
          res += f.minuti;
        });
      return res;
    },
    totale_pezzi: {
      get() {
        let res = 0;
        this.items_pezzi_ok
          .filter((elem) => elem.validita == 1)
          .forEach((p) => {
            res += p.quantita;
          });
        return res;
      },
      set() {
        let res = 0;
        this.items_pezzi_ok
          .filter((elem) => elem.validita == 1)
          .forEach((p) => {
            res += p.quantita;
          });
        return res;
      },
    },
    totale_scarti() {
      let res = 0;
      this.items_scarti
        .filter((elem) => elem.validita == 1)
        .forEach((s) => {
          res += s.pezzi;
        });
      return res;
    },
  },
  watch: {
    "riga_generale.id_commessa_dettaglio": {
      immediate: true,
      handler() {
        if (
          this.riga_generale.id_commessa_dettaglio != null &&
          this.riga_generale.id_commessa_dettaglio !== "" &&
          this.riga_generale.id_commessa_dettaglio > 0
        ) {
          this.items_fasi_selezionabili.forEach((f) => {
            if (
              f.id_commessa_dettaglio ==
              this.riga_generale.id_commessa_dettaglio
            ) {
              // Registro l'id_fase.
              this.riga_generale.id_fase = f.id_fase;

              // Registro se è o meno un'ultima fase.
              if (
                this.items_fasi_selezionabili.filter(
                  (elem) => elem.cod_fase > f.cod_fase
                ).length == 0
              ) {
                this.riga_generale.flag_fase_ultima = 1;
              } else {
                this.riga_generale.flag_fase_ultima = 0;
              }
            }
          });

          this.getCommessaRegistrazione();
          this.getCausaliFermo();
        }
      },
    },
  },
  methods: {
    checkCalendarInterval() {
      const start_tmp = moment(this.riga_generale.data_start);
      const stop_tmp = moment(this.riga_generale.data_stop);
      const diff = stop_tmp.diff(start_tmp, "months", false);

      if (diff > 0) {
        this.differenza_tempi = diff;
        this.dialog_avviso_tempi = true;
      }
    },
    startString() {
      this.dialog_stringa = true;
      this.stringa = "";
    },
    appendString(arg) {
      this.stringa += arg.detail.testo + "\n";
    },
    stopString() {
      this.$refs.SnackbarQV.print("success", "Registrazione terminata.");
    },
    aggiungiDichiarazionePezzi() {
      this.dialog_edit_pezzo = true;
      this.pezzo_sel = new CollateralePezzi();

      /* Preparo i campi con i valori definiti in base al contesto,
       * che dovranno poi essere salvati in commessa_movimenti. */
      this.pezzo_sel.id_movimento = -moment().valueOf();
      this.pezzo_sel.id_articolo = this.riga_generale.id_articolo;
      this.pezzo_sel.id_commessa = this.riga_generale.id_commessa;
      this.pezzo_sel.id_commessa_dettaglio =
        this.riga_generale.id_commessa_dettaglio;
      this.pezzo_sel.id_macchina = this.riga_generale.id_macchina;
      this.pezzo_sel.data = `${this.riga_generale.data_stop} ${this.riga_generale.ora_stop}`;
      this.pezzo_sel.nominativo = this.items_utenti.filter(
        (p) => p.id_personale == this.riga_generale.id_personale
      )[0].nominativo;
      this.pezzo_sel.id_personale = this.riga_generale.id_personale;
      this.pezzo_sel.cod_macchina = this.items_macchine_selezionabili.filter(
        (m) => m.id_macchina == this.riga_generale.id_macchina
      )[0].cod_macchina;
      this.pezzo_sel.cod_fase = this.items_fasi_selezionabili.filter(
        (f) => f.id_fase == this.riga_generale.id_fase
      )[0].cod_fase;
      this.pezzo_sel.des_fase = this.items_fasi_selezionabili.filter(
        (f) => f.id_fase == this.riga_generale.id_fase
      )[0].des_fase;
      this.pezzo_sel.cod_commessa = this.riga_generale.cod_commessa;
      this.pezzo_sel.riferimento = this.riga_generale.riferimento;
    },
    aggiungiRigaFermi() {
      this.items_fermi_tmp.push(
        new Causale({
          id_commessa_causale: -moment().valueOf(),
          tipo_causale: "FASE_causali",
          tipo_record: "M",
        })
      );
    },
    aggiungiRigaScarti() {
      this.items_scarti_tmp.push(
        new Causale({
          id_commessa_causale: -moment().valueOf(),
          tipo_causale: "PRODUZIONE_CAUSALI",
          tipo_record: "M",
        })
      );
    },
    cercaCommesse() {
      if (
        this.riga_generale.cod_commessa == null ||
        this.riga_generale.cod_commessa == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire un codice commessa da ricercare."
        );
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaconsuntivi",
          token: localStorage.user_token,
          cod_commessa: this.riga_generale.cod_commessa,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            if (res.data.lista.length === 1) {
              this.riga_generale.id_commessa = res.data.lista[0].id_commessa;
              this.riga_generale.cod_commessa = res.data.lista[0].cod_commessa;
              this.riga_generale.cod_articolo = res.data.lista[0].cod_articolo;
              this.getFasiCommessa();
            } else if (res.data.lista.length > 0) {
              res.data.lista.forEach((elem) => {
                elem.visible = 1;
              });

              this.items_commesse_selezionabili = res.data.lista;
              this.dialog_seleziona_commessa = true;
              this.cod_articolo_filter = "";
              this.cod_commessa_filter = "";
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessuna commessa corrisponde alla ricerca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    chiudiDialogPezzi() {
      this.dialog_pezzi = false;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickEliminaCausaleFermo(arg) {
      this.causale_fermo_sel = new Causale(arg);
      this.dialog_conferma_elimina_fermo = true;
    },
    clickEliminaCausaleScarto(arg) {
      this.causale_scarto_sel = new Causale(arg);
      this.dialog_conferma_elimina_scarto = true;
    },
    clickEliminaPezzo(arg) {
      this.pezzo_sel = new CollateralePezzi(arg);
      this.dialog_conferma_elimina_pezzo = true;
    },
    eliminaCausaleFermo() {
      this.items_fermi_tmp.forEach((f) => {
        if (
          f.id_commessa_causale == this.causale_fermo_sel.id_commessa_causale
        ) {
          f.validita = 0;
        }
      });
      this.dialog_conferma_elimina_fermo = false;
    },
    eliminaCausaleScarto() {
      this.items_scarti_tmp.forEach((s) => {
        if (
          s.id_commessa_causale == this.causale_scarto_sel.id_commessa_causale
        ) {
          s.validita = 0;
        }
      });
      this.dialog_conferma_elimina_scarto = false;
    },
    eliminaPezzo() {
      this.items_pezzi_ok_tmp.forEach((p) => {
        if (p.id_movimento == this.pezzo_sel.id_movimento) {
          p.validita = 0;
        }
      });
      this.dialog_conferma_elimina_pezzo = false;
    },
    filtra() {
      /* Preparo un array temporaneo in cui
       * collezionare le commesse filtrate */
      let commesse_tmp = [];
      this.items_commesse_selezionabili.forEach((e) => {
        const obj_tmp = Object.assign({}, e);
        obj_tmp.visible = 1;
        commesse_tmp.push(obj_tmp);
      });

      // Filtro per codice commessa.
      if (this.cod_commessa_filter != null && this.cod_commessa_filter != "") {
        commesse_tmp.forEach((elem) => {
          if (!(elem.cod_commessa === this.cod_commessa_filter)) {
            if (elem.visible === 1) {
              elem.visible = 0;
            }
          }
        });
      }

      // Filtro per codice articolo.
      if (this.cod_articolo_filter != null && this.cod_articolo_filter != "") {
        commesse_tmp.forEach((elem) => {
          if (!(elem.cod_articolo === this.cod_articolo_filter)) {
            if (elem.visible === 1) {
              elem.visible = 0;
            }
          }
        });
      }

      // Ricostruisco le commesse visualizzate in base alle commesse filtrate.
      this.items_commesse_selezionabili = Array.from(commesse_tmp);
    },
    getCausaliFermo() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "FASE_causali",
          filter:
            "(val_int IS NULL OR val_int = " +
            this.riga_generale.id_fase +
            ") AND validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_causali_fermo = new Array();
            this.items_causali_fermo = res.data;
            return 0;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return 1;
          }
        })
        .catch((e) => {
          console.error(e);

          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return 1;
        });
    },
    getCommessaRegistrazione() {
      let getcommessaregistrazione = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaregistrazione",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: this.riga_generale.id_commessa_dettaglio,
        },
      };

      return this.$store
        .dispatch("api", getcommessaregistrazione)
        .then((res) => {
          if (res.status === 200) {
            // Azzero l'array delle causali di scarto.
            this.items_causali_scarto = new Array();

            // Inserisco le causali che mi dice il backend
            res.data.forEach((elem) => {
              this.items_causali_scarto.push(elem);
            });
            return 0;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
            return 1;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
          return 1;
        });
    },
    getFasiCommessa() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.user_token,
          id_commessa: this.riga_generale.id_commessa,
          id_profilo: localStorage.id_profilo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.commessa_dettaglio.forEach((f) => {
              f.cod_des_fase = `${f.cod_fase} - ${f.des}`;
            });

            this.items_fasi_selezionabili = res.data.commessa_dettaglio;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getCommessaCausaliScartoFermo() {
      /* Se id_commessa_tempi della riga generale è nullo vuol dire che
       * sto chiamando il componente per visualizzare una nuova dichiarazione
       * copiata da un'altra dichiarazione ed entrambe devono ancora essere
       * salvate per cui è inutile che cerco scarti e fermi sul DB. */
      if (this.riga_generale.id_commessa_tempi == null) {
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessacausaliscartofermo",
          token: localStorage.user_token,
          id_commessa_tempi: this.riga_generale.id_commessa_tempi,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.items_scarti = new Array();
            this.items_fermi = new Array();
            res.data.result.commessa_causali.forEach((elem) => {
              if (elem.tipo_causale === "PRODUZIONE_CAUSALI") {
                this.items_scarti.push(elem);
              } else {
                this.items_fermi.push(elem);
              }
            });
          } else {
            this.caricamento_dati = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getListaMacchine() {
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.macchine.forEach((m) => {
              m.cod_des_macchina = `${m.des_macchina} - ${m.cod_macchina}`;
            });

            this.items_macchine_selezionabili = res.data.macchine;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
    getPersonale() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getutenti",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.forEach((d) => {
              d.nominativo = `${d.nome} ${d.cognome}`;
            });
            this.items_utenti = res.data ? res.data : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    getPezzi() {
      /* Se id_commessa_tempi della riga generale è nullo vuol dire che
       * sto chiamando il componente per visualizzare una nuova dichiarazione
       * copiata da un'altra dichiarazione ed entrambe devono ancora essere
       * salvate per cui è inutile che cerco pezzi registrati sul DB. */
      if (this.riga_generale.id_commessa_tempi == null) {
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaavanzamento",
          token: localStorage.getItem("user_token"),
          tipo: "p",
          analisi: "d",
          id_commessa_tempi: this.riga_generale.id_commessa_tempi,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        // Svuoto l'array che contiene i dati dell'avanzamento
        this.items_pezzi_ok = new Array();
        this.items_pezzi_ok = res.data;
      });
    },
    getTipoCausali() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "TIPO_CAUSALE_FERMO",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.tabella_parametri_query = new Array();
            this.items_tipi_causali = new Array();

            if (res.data != null && res.data != "") {
              this.items_tipi_causali =
                res.data != null && res.data != "" ? res.data : new Array();

              // imposto i val_int a 0
              this.items_tipi_causali.forEach((i) => (i.val_int = 0));
            }

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);

          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          return false;
        });
    },
    getTurni() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getturnocodici",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_turni = res.data.result.turno_codici;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    modificaSingolaRigaPezzi(arg) {
      this.pezzo_sel = new CollateralePezzi(arg);
      this.dialog_edit_pezzo = true;
    },
    salvaFermi() {
      // Controllo le quantità.
      if (
        this.items_fermi_tmp.filter(
          (elem) =>
            elem.validita == 1 &&
            (elem.minuti == null || elem.minuti === "" || elem.minuti == 0)
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Dichiarare i minuti per ogni riga."
        );
        return;
      }

      // Controllo le causali.
      if (
        this.items_fermi_tmp.filter(
          (elem) =>
            elem.validita == 1 &&
            (elem.id_causale == null || elem.id_causale === "")
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Dichiarare la causale per ogni riga."
        );
        return;
      }

      this.items_fermi = JSON.parse(JSON.stringify(this.items_fermi_tmp));
      this.dialog_fermi = false;
    },
    salvaPezziOK() {
      this.items_pezzi_ok = JSON.parse(JSON.stringify(this.items_pezzi_ok_tmp));
      this.dialog_pezzi = false;
    },
    salvaPezzo() {
      if (this.pezzo_sel.quantita == null || this.pezzo_sel.quantita == "") {
        this.$refs.SnackbarQV.print("orange", "Inserire una quantità.");
        return;
      }

      // Se il pezzo non c'era già, lo aggiungo.
      if (
        this.items_pezzi_ok_tmp.filter(
          (e) => e.id_movimento == this.pezzo_sel.id_movimento
        ).length == 0
      ) {
        this.pezzo_sel.tipo_record = "M";
        this.items_pezzi_ok_tmp.push(new CollateralePezzi(this.pezzo_sel));
      } else {
        // Se c'era, lo aggiorno.
        this.items_pezzi_ok_tmp.forEach((elem) => {
          if (elem.id_movimento == this.pezzo_sel.id_movimento) {
            elem.note = this.pezzo_sel.note;
            elem.quantita = this.pezzo_sel.quantita;
          }
        });
      }
      this.dialog_edit_pezzo = false;
    },
    async salvaRigaGenerale() {
      // Controllo che ci sia una commessa.
      if (
        this.riga_generale.id_commessa == null ||
        this.riga_generale.id_commessa === ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare una commessa.");
        return;
      }

      // Controllo che ci sia una fase.
      if (
        this.riga_generale.id_fase == null ||
        this.riga_generale.id_fase === ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare una fase.");
        return;
      }

      // Controllo che ci sia una macchina.
      if (
        this.riga_generale.id_macchina == null ||
        this.riga_generale.id_macchina === ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare una macchina.");
        return;
      }

      // Controllo che ci sia un'ora di start.
      if (
        this.riga_generale.ora_start == null ||
        this.riga_generale.ora_start === ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un'ora di start.");
        return;
      }

      // Controllo che ci sia un'ora di stop.
      if (
        this.riga_generale.ora_stop == null ||
        this.riga_generale.ora_stop === ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un'ora di stop.");
        return;
      }

      // Controllo che ci sia un addetto.
      if (
        this.riga_generale.id_personale == null ||
        this.riga_generale.id_personale === ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare il personale.");
        return;
      }

      // Controllo la coerenza delle date e delle ore.
      if (
        moment(
          `${this.riga_generale.data_start} ${this.riga_generale.ora_start}`
        ).isAfter(
          moment(
            `${this.riga_generale.data_stop} ${this.riga_generale.ora_stop}`
          )
        )
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I momenti di start e stop sono incompatibili."
        );
        return;
      }

      // Prendo da parte i pezzi.
      const pezzi_ok_tmp = new Array();

      this.items_pezzi_ok
        .filter((elem) => elem.validita == 1 || elem.id_movimento > 0)
        .forEach((elem) => {
          const elem_tmp = new CollateralePezzi(elem);

          /* Questo postulato condizionale serve per evitare di portare
           * a nulla la data in commessa_movimenti nell'esecuzione della
           * logica di salvataggio nel BE. */
          if (elem._ora != null && elem._ora != "") {
            elem_tmp.data = `${elem._ora.substr(6, 4)}-${elem._ora.substr(
              3,
              2
            )}-${elem._ora.substr(0, 2)} ${elem._ora.substr(11, 8)}`;
          }

          elem_tmp.id_commessa_tempi = this.riga_generale.id_commessa_tempi;
          elem_tmp.id_commessa_movimenti = elem_tmp.id_movimento;

          if (elem_tmp.id_commessa_movimenti < 0) {
            elem_tmp.id_commessa_movimenti = -1;
          }

          /*if (elem_tmp._ora && elem_tmp._ora.length > 0) {
            elem_tmp.data = `${elem_tmp._ora.substr(
              6,
              4
            )}-${elem_tmp._ora.substr(3, 2)}-${elem_tmp._ora.substr(
              0,
              2
            )} ${elem_tmp._ora.substr(11, 8)}`;
          }*/

          pezzi_ok_tmp.push(elem_tmp);
        });

      // Prendo da parte i fermi.
      const items_fermi_tmp = new Array();

      this.items_fermi
        .filter((elem) => elem.validita == 1 || elem.id_commessa_causale > 0)
        .forEach((elem) => {
          const elem_tmp = new Causale(elem);
          elem_tmp.id_commessa_tempi = this.riga_generale.id_commessa_tempi;
          elem_tmp.tipo_causale = "FERMO";
          if (elem_tmp.id_commessa_causale < 0) {
            elem_tmp.id_commessa_causale = -1;
          }

          items_fermi_tmp.push(elem_tmp);
        });

      // Prendo da parte gli scarti.
      const items_scarti_tmp = new Array();

      this.items_scarti
        .filter((elem) => elem.validita == 1 || elem.id_commessa_causale > 0)
        .forEach((elem) => {
          const elem_tmp = new Causale(elem);
          elem_tmp.id_commessa_tempi = this.riga_generale.id_commessa_tempi;
          elem_tmp.tipo_causale = "SCARTO";
          if (elem_tmp.id_commessa_causale < 0) {
            elem_tmp.id_commessa_causale = -1;
          }

          items_scarti_tmp.push(elem_tmp);
        });

      // Preparo la request.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "addconsuntivogenerale",
          token: localStorage.user_token,
          tempi: [
            {
              id_commessa_tempi: this.riga_generale.id_commessa_tempi,
              id_causale: 55,
              id_personale: this.riga_generale.id_personale,
              id_commessa: this.riga_generale.id_commessa,
              id_commessa_dettaglio: this.riga_generale.id_commessa_dettaglio,
              id_macchina: this.riga_generale.id_macchina,
              data: `${this.riga_generale.data_start} ${this.riga_generale.ora_start}`,
              ora_inizio: `${this.riga_generale.data_start} ${this.riga_generale.ora_start}`,
              ora_fine: `${this.riga_generale.data_stop} ${this.riga_generale.ora_stop}`,
              id_turno: this.riga_generale.id_turno,
            },
          ],
          pezzi: pezzi_ok_tmp,
          scarti: items_scarti_tmp,
          fermi: items_fermi_tmp,
        },
      };

      // Se sto salvando una riga nuova registro che è aggiunta a mano.
      if (this.riga_generale.id_commessa_tempi < 0) {
        request.richiesta.tempi[0].tipo_record = "M";
      }

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.$emit("salvata_riga");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    salvaScarti() {
      // Controllo le quantità.
      if (
        this.items_scarti_tmp.filter(
          (elem) =>
            elem.validita == 1 &&
            (elem.pezzi == null || elem.pezzi === "" || elem.pezzi == 0)
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Dichiarare la quantità per ogni riga."
        );
        return;
      }

      // Controllo le causali.
      if (
        this.items_scarti_tmp.filter(
          (elem) =>
            elem.validita == 1 &&
            (elem.id_causale == null || elem.id_causale === "")
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Dichiarare la causale per ogni riga."
        );
        return;
      }

      this.items_scarti = JSON.parse(JSON.stringify(this.items_scarti_tmp));
      this.dialog_scarti = false;
    },
    selezionaCommessa(arg) {
      this.riga_generale.id_commessa = arg.id_commessa;
      this.riga_generale.cod_commessa = arg.cod_commessa;
      this.riga_generale.cod_articolo = arg.cod_articolo;
      this.riga_generale.riferimento = arg.riferimento;
      this.riga_generale.id_articolo = arg.id_articolo;
      this.dialog_seleziona_commessa = false;
      this.getFasiCommessa();
    },
    showFermi() {
      if (
        this.riga_generale.id_fase == null ||
        this.riga_generale.id_fase == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare una fase di lavorazione."
        );
        return;
      }

      this.items_fermi_tmp = JSON.parse(JSON.stringify(this.items_fermi));
      this.dialog_fermi = true;
    },
    showPezzi() {
      if (
        this.riga_generale.id_fase == null ||
        this.riga_generale.id_fase == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare una fase di lavorazione."
        );
        return;
      }

      if (
        this.riga_generale.data_stop == null ||
        this.riga_generale.data_stop == "" ||
        this.riga_generale.ora_stop == null ||
        this.riga_generale.ora_stop == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare data e ora di fine prima di registrare i pezzi."
        );
        return;
      }

      this.items_pezzi_ok_tmp = JSON.parse(JSON.stringify(this.items_pezzi_ok));
      this.dialog_pezzi = true;
    },
    showScarti() {
      if (
        this.riga_generale.id_commessa_dettaglio == null ||
        this.riga_generale.id_commessa_dettaglio == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare una fase di lavorazione."
        );
        return;
      }
      this.items_scarti_tmp = JSON.parse(JSON.stringify(this.items_scarti));
      this.dialog_scarti = true;
    },
  },
  created() {},
  async mounted() {
    document
      .getElementById("listener_aggiunta_riga_generale")
      .addEventListener("start_string", this.startString);

    document
      .getElementById("listener_aggiunta_riga_generale")
      .addEventListener("append_string", this.appendString);

    document
      .getElementById("listener_aggiunta_riga_generale")
      .addEventListener("stop_string", this.stopString);

    // Valorizzo le autocomplete che posso.
    this.getPersonale();
    this.getListaMacchine();
    this.getTipoCausali();
    this.getTurni();

    // Se sto modificando una riga...
    if (
      this.riga_ori.id_commessa != null &&
      this.riga_ori.id_commessa != "" &&
      this.riga_ori.id_commessa != -1
    ) {
      this.riga_generale = new RigaGenerale(this.riga_ori);

      this.caricamento_dati = true;
      await this.getCommessaRegistrazione();
      await this.getCausaliFermo();
      this.caricamento_dati = false;

      this.getFasiCommessa();
      this.getPezzi();
      this.getCommessaCausaliScartoFermo();
    } else {
      // Se invece sto creando una riga nuova imposto solo i tempi.
      this.riga_generale.data_start = moment().format("YYYY-MM-DD");
      this.riga_generale.data_stop = moment().format("YYYY-MM-DD");
    }
  },
};
</script>
<style scoped>
</style>